(ns minorodata.warehouse-usage.subs
  (:require
   [re-frame.core :as re-frame]))


(re-frame/reg-sub
 :warehouse-usage.subs/service-breakdown-status
 (fn [db]
   (get-in db [:warehouse-usage :service-breakdown-status])))

(re-frame/reg-sub
 :warehouse-usage.subs/service-breakdown
 (fn [db]
   (get-in db [:warehouse-usage :service-breakdown])))

(re-frame/reg-sub
 :warehouse-usage.subs/user-warehouse-usage-status
 (fn [db]
   (get-in db [:warehouse-usage :user-warehouse-usage-status])))

(re-frame/reg-sub
 :warehouse-usage.subs/user-warehouse-usage
 (fn [db]
   (get-in db [:warehouse-usage :user-warehouse-usage])))

(re-frame/reg-sub
 :warehouse-usage.subs/warehouse-credits-status
 (fn [db]
   (get-in db [:warehouse-usage :warehouse-credits-status])))

(re-frame/reg-sub
 :warehouse-usage.subs/warehouse-credits
 (fn [db]
   (get-in db [:warehouse-usage :warehouse-credits])))


(defn- group-sum [key-fn val-fn rows]
  (reduce (fn [totals row]
            (update totals (key-fn row) (fnil + 0) (val-fn row)))
          {}
          rows))

(defn- sorted-totals [totals]
  (->> totals
       (map (fn [[name credits]] {:name name :credits credits}))
       (sort-by :credits >)
       vec))

(defn- metrics [service-rows]
  (let [by-category     (group-sum :service-category :credits service-rows)
        compute-credits (get by-category "Warehouse Compute" 0)
        cloud-credits   (get by-category "Cloud Services (Gross)" 0)]
    {:total-billed-credits   (reduce + 0 (vals by-category))
     :total-credits          (+ compute-credits cloud-credits)
     :compute-credits        compute-credits
     :cloud-services-credits cloud-credits}))

(def bucket-date-key "__usage_bucket_date__")
(def bucket-total-key "__usage_bucket_total__")

(defn- credits-used
  [warehouse-series]
  (let [warehouse-totals (group-sum :warehouse-name :credits-used warehouse-series)
        series           (->> warehouse-totals (sort-by val >) (mapv key))
        buckets          (->> warehouse-series
                              (group-by :bucket)
                              (map (fn [[bucket bucket-rows]]
                                     (reduce (fn [row {:keys [warehouse-name credits-used]}]
                                               (-> row
                                                   (assoc warehouse-name credits-used)
                                                   (update bucket-total-key + credits-used)))
                                             {bucket-date-key bucket bucket-total-key 0}
                                             bucket-rows)))
                              (sort-by #(get % bucket-date-key))
                              vec)]
    {:credits-used  buckets
     :credit-series series}))

(defn build-view-model [summary]
  (let [service-rows (:service-breakdown summary)]
    (merge
     {:metrics             (metrics service-rows)
      :service-categories  (sorted-totals (group-sum :service-category :credits service-rows))
      :users               (->> (:user-warehouse-usage summary)
                                (group-sum :user-name :sum-total-billed-credits)
                                sorted-totals)
      :warehouses          (->> (:user-warehouse-usage summary)
                                (group-sum :warehouse-name :sum-total-billed-credits)
                                sorted-totals)}
     (credits-used (:warehouse-series summary)))))
